<div class="form-container">
  <hau-form [formGroup]="form">
    <hau-form-field label="Kürzel" cols="3" [validation]="form.validation.shortcut">
      <input nbInput fullWidth formControlName="shortcut" placeholder="z.B. JP">
    </hau-form-field>
    <hau-form-field label="Name" cols="9" [validation]="form.validation.name">
      <input nbInput fullWidth formControlName="name" placeholder="Protokolltyp Name">
    </hau-form-field>
    <hau-form-field label="Farbe" cols="6" [validation]="form.validation.color">
      <wr-color-preset-picker formControlName="color"></wr-color-preset-picker>
    </hau-form-field>
    <hau-form-field label="Beschreibung" [validation]="form.validation.description">
      <textarea nbInput fullWidth formControlName="description" rows="4" placeholder="Beschreibung..."></textarea>
    </hau-form-field>
  </hau-form>
</div>
